function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext, useId } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Heading } from '../../atoms';
import { ProfileImage } from '../ProfileImage';
import { Tag } from '../Tag';
import ReactConfigContext from '../../ReactConfigContext';
export default function WorkgroupCard(param) {
    var _param_size = param.size, size = _param_size === void 0 ? 'default' : _param_size, image = param.image, title = param.title, color = param.color, description = param.description, tags = param.tags, badges = param.badges, action = param.action, className = param.className;
    var id = useId();
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, LinkComponent = _useContext_config.LinkComponent, ImageComponent = _useContext_config.ImageComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge('isolate relative rounded-xl bg-bg-subtle p-7', size === 'small' && 'p-6 sm:p-7', className)
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        className: twMerge('block', action.className)
    }), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('flex justify-between', size === 'small' && 'justify-start items-center sm:items-start sm:justify-between')
    }, /*#__PURE__*/ React.createElement(ProfileImage, {
        image: image,
        color: color,
        className: twMerge(size === 'default' && 'w-[11.5rem]', size === 'small' && 'w-[5.375rem] sm:w-[7.125rem]')
    }), /*#__PURE__*/ React.createElement("div", {
        className: "ml-6"
    }, size === 'small' && /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4",
        className: "mb-3 sm:hidden"
    }, title), !!(badges === null || badges === void 0 ? void 0 : badges.length) && /*#__PURE__*/ React.createElement("div", {
        className: twMerge('flex justify-end', size === 'small' && 'justify-start sm:justify-end')
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('grid gap-3 grid-cols-1 grid-flow-row auto-rows-max', size === 'small' && 'grid-flow-col grid-rows-1 auto-cols-max sm:grid-cols-1 sm:grid-flow-row sm:auto-rows-max')
    }, badges.map(function(badge) {
        var _image_sizes;
        return /*#__PURE__*/ React.createElement("div", {
            key: badge.image.src,
            className: twMerge('flex items-center justify-center', 'rounded-full overflow-hidden', size === 'default' && 'w-[3.375rem] h-[3.375rem]', size === 'small' && 'w-[2.5rem] h-[2.5rem]')
        }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, badge.image), {
            sizes: (_image_sizes = image.sizes) !== null && _image_sizes !== void 0 ? _image_sizes : '150px',
            className: twMerge('w-full h-full object-cover object-center', badge.image.className)
        })));
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('mt-7', size === 'small' && 'hidden sm:block')
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "mt-3"
    }, description))), !!(tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ React.createElement("div", {
        className: twMerge('mt-5', size === 'small' && 'hidden sm:block')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max justify-items-start gap-3"
    }, tags.map(function(tag) {
        return /*#__PURE__*/ React.createElement(Tag, _object_spread({
            key: "tag-".concat(id, "-").concat(tag.href),
            variant: "ghost",
            size: size === 'small' ? 'sm' : 'default'
        }, tag), tag.label);
    }))));
}

//# sourceMappingURL=WorkgroupCard.js.map